import { Close } from "@mui/icons-material";
import { Chip, Stack, Typography } from "@mui/material";

interface Filter {
	key: string;
	label: string;
	value: string;
	displayValue: string;
}

interface ActiveFiltersStackProps {
	activeFilters: Filter[];
	onRemoveFilter: (key: string, value: string) => void;
	onClearAll: () => void;
}

export const ActiveFiltersStack: React.FC<ActiveFiltersStackProps> = ({
	activeFilters,
	onRemoveFilter,
	onClearAll,
}) => {
	return (
		<Stack direction="row" flexWrap="wrap" gap={0.5}>
			{activeFilters.map((filter) => (
				<Chip
					key={`${filter.key}:${filter.value}`}
					label={
						<Stack direction="row" spacing={0.5} alignItems="center">
							<Typography color="text.primary" variant="subtitle2">
								{filter.label}:
							</Typography>
							<Typography variant="body1" fontWeight={700}>
								{filter.displayValue}
							</Typography>
						</Stack>
					}
					onDelete={() => onRemoveFilter(filter.key, filter.value)}
					deleteIcon={<Close fontSize="small" />}
					variant="outlined"
					size="small"
					sx={{
						border: "1px solid",
						borderColor: "primary.400",
						backgroundColor: "transparent",
						borderRadius: 2,
						height: "auto",
						minHeight: 24,
						"&:hover": {
							backgroundColor: "primary.50",
							borderColor: "primary.500",
						},
					}}
				/>
			))}

			{activeFilters.length > 1 && (
				<Chip
					label={<Typography variant="body1">Clear all filters</Typography>}
					onClick={onClearAll}
					variant="outlined"
					size="medium"
					color="error"
					sx={{
						fontWeight: 600,
						borderStyle: "dashed",
						borderWidth: 2,
						borderColor: "error.400",
						color: "error.700",
						borderRadius: 2,
						height: "auto",
						minHeight: 28,
						py: 0.25,
						"&:hover": {
							borderStyle: "solid",
							backgroundColor: "error.50",
							borderColor: "error.500",
							color: "error.800",
						},
					}}
				/>
			)}
		</Stack>
	);
};
